import {
  Unit_instanceat14thlj150z as Unit_instance,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  VOID7hggqo3abtya as VOID,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration7gy6v749ektt as toDuration,
  coerceIn10f36k81le1mm as coerceIn,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  indexOfj0u699sj4o53 as indexOf,
  copyOfwy6h3t5vzqpl as copyOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  coerceIn302bduskdb54x as coerceIn_0,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Paire9pteg33gng7 as Pair,
  until1jbpn0z3f8lbg as until,
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains2c50nlxg7en7o as contains,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  createThis2j2avj17cvnv2 as createThis,
  printStackTrace18lnx7a39cni as printStackTrace,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toString30pk9tzaqopn as toString_0,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  decodeToString1x4faah2liw2p as decodeToString,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Channel3r72atmcithql as Channel,
  delay1blitpytzu6gr as delay,
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
  Mutex16li1l0asjv17 as Mutex,
} from './kotlinx-coroutines-core.mjs';
import {
  ilog23dbvpk38jf7rc as ilog2,
  nextAlignedTo3ni8b2boh3zjg as nextAlignedTo,
  toIntClampad53d0g5q5oi as toIntClamp,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  SimpleBytesDeque3uob1f4dosqej as SimpleBytesDeque,
  SimpleChunkedByteDeque3cr64mogfywgm as SimpleChunkedByteDeque,
  getS83kqgdtkseh4fp as getS8,
  getU83agrw8yj0shar as getU8,
  getS16BE6c2odqehs5au as getS16BE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24BE36pml41y2814b as getU24BE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getS64BE1b3e93qe1xjxx as getS64BE,
  getS8Array1clq6jd2z5jh9 as getS8Array,
  getS16ArrayBE3bj6gsad0tz3k as getS16ArrayBE,
  getU16ArrayBE1cpolqhg4wxps as getU16ArrayBE,
  getS32ArrayLE2u84ix7qnexrb as getS32ArrayLE,
  getS32ArrayBE30ehj217529qp as getS32ArrayBE,
  getS16LE39jsuv9u9gi4y as getS16LE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getU32LE1yo0ft9yyv0wa as getU32LE,
  getU16LE2cizldw8qp53x as getU16LE,
  set16LEde5pevq9ub88 as set16LE,
  set32LE38ba9cwhp6kc as set32LE,
  set32BEeq1a5bkwt9ix as set32BE,
  arraycopy3czrd9re36wzt as arraycopy,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  OutOfBoundsException1k0x58dcca6fx as OutOfBoundsException,
  Endian_LITTLE_ENDIAN_getInstance29hybk19wzxil as Endian_LITTLE_ENDIAN_getInstance,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  EOFExceptiona2wwqnj55hh5 as EOFException,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  toString2x583ovdqfjci as toString_1,
  get_UTF82geyfhi1l22xl as get_UTF8,
} from './korlibs-string-root-korlibs-string.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class AsyncOutputStream {}
function write$default(buffer, offset, len, $completion, $super) {
  offset = offset === VOID ? 0 : offset;
  len = len === VOID ? buffer.length - offset | 0 : len;
  return $super === VOID ? this.j1s(buffer, offset, len, $completion) : $super.j1s.call(this, buffer, offset, len, $completion);
}
function write(byte, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_5.bind(VOID, this, byte), $completion);
}
class AsyncRingBuffer {
  constructor(bufferSize) {
    bufferSize = bufferSize === VOID ? 1024 : bufferSize;
    this.d1s_1 = bufferSize;
    this.e1s_1 = null;
    this.f1s_1 = Channel(-1);
    this.g1s_1 = Channel(-1);
    this.h1s_1 = new SimpleBytesDeque(ilog2(this.d1s_1) + 1 | 0);
    this.i1s_1 = false;
  }
  j1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l.bind(VOID, this, buffer, offset, len), $completion);
  }
  l1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, buffer, offset, len), $completion);
  }
  m1s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0.bind(VOID, this), $completion);
  }
  toString() {
    return 'AsyncByteArrayDeque(' + this.e1s_1 + ')';
  }
}
class Companion {
  constructor() {
    this.o1s_1 = 8388608;
  }
}
class AsyncRingBufferChunked {
  constructor(maxSize) {
    maxSize = maxSize === VOID ? 8388608 : maxSize;
    this.p1s_1 = maxSize;
    this.q1s_1 = null;
    this.r1s_1 = new SimpleChunkedByteDeque();
    this.s1s_1 = false;
  }
  j1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_0.bind(VOID, this, buffer, offset, len), $completion);
  }
  n1s(byte, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_1.bind(VOID, this, byte), $completion);
  }
  l1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0.bind(VOID, this, buffer, offset, len), $completion);
  }
  m1s($completion) {
    this.s1s_1 = true;
  }
  toString() {
    return 'AsyncByteArrayDequeV2(' + this.q1s_1 + ')';
  }
}
class FastByteArrayInputStream {
  constructor(ba, offset, start, end) {
    offset = offset === VOID ? 0 : offset;
    start = start === VOID ? 0 : start;
    end = end === VOID ? ba.length : end;
    this.t1s_1 = ba;
    this.u1s_1 = start;
    this.v1s_1 = end;
    this.w1s_1 = offset + this.u1s_1 | 0;
  }
  x1s(value) {
    this.w1s_1 = this.u1s_1 + value | 0;
  }
  y1s() {
    return this.w1s_1 - this.u1s_1 | 0;
  }
  a() {
    return this.v1s_1 - this.u1s_1 | 0;
  }
  sy() {
    return this.v1s_1 - this.w1s_1 | 0;
  }
  yy() {
    return this.sy() > 0;
  }
  z1s(_this__u8e3s4) {
    return coerceIn(_this__u8e3s4, this.u1s_1, this.v1s_1);
  }
  a1t(size) {
    var out = this.b1t(this.y1s(), size);
    this.w1s_1 = this.w1s_1 + size | 0;
    return out;
  }
  c1t(offset) {
    return new FastByteArrayInputStream(this.t1s_1, 0, this.z1s(this.u1s_1 + offset | 0), this.v1s_1);
  }
  d1t(offset, $super) {
    offset = offset === VOID ? 0 : offset;
    return $super === VOID ? this.c1t(offset) : $super.c1t.call(this, offset);
  }
  o10() {
    return new FastByteArrayInputStream(this.t1s_1, this.y1s(), this.u1s_1, this.v1s_1);
  }
  b1t(offset, len) {
    return new FastByteArrayInputStream(this.t1s_1, 0, this.z1s(this.u1s_1 + offset | 0), this.z1s((this.u1s_1 + offset | 0) + len | 0));
  }
  dz(count) {
    this.w1s_1 = coerceIn(this.w1s_1 + count | 0, this.u1s_1, this.v1s_1);
  }
  e1t(count) {
    return this.dz(-count | 0);
  }
  f1t(len) {
    var out = copyOfRange(this.t1s_1, this.w1s_1, this.w1s_1 + len | 0);
    this.w1s_1 = this.w1s_1 + len | 0;
    return out;
  }
  g1t() {
    return getS8(this.t1s_1, offset(this, 1));
  }
  h1t() {
    return getU8(this.t1s_1, offset(this, 1));
  }
  i1t() {
    return getS16BE(this.t1s_1, offset(this, 2));
  }
  j1t() {
    return getU16BE(this.t1s_1, offset(this, 2));
  }
  k1t() {
    return getU24BE(this.t1s_1, offset(this, 3));
  }
  l1t() {
    return getS32BE(this.t1s_1, offset(this, 4));
  }
  m1t() {
    return getS64BE(this.t1s_1, offset(this, 8));
  }
  n1t(count) {
    return getS8Array(this.t1s_1, offset(this, count), count);
  }
  o1t(count) {
    return getS16ArrayBE(this.t1s_1, offset(this, imul(count, 2)), count);
  }
  p1t(count) {
    return getU16ArrayBE(this.t1s_1, offset(this, imul(count, 2)), count);
  }
  q1t(count) {
    return getS32ArrayLE(this.t1s_1, offset(this, imul(count, 4)), count);
  }
  r1t(count) {
    return getS32ArrayBE(this.t1s_1, offset(this, imul(count, 4)), count);
  }
  s1t(offset, length, charset) {
    var start = this.u1s_1 + offset | 0;
    var end = start + length | 0;
    return toString_1(this.t1s_1, charset, start, end);
  }
  t1t(len, charset) {
    var res = this.n1t(len);
    var index = indexOf(res, 0);
    return toString_1(copyOf(res, index < 0 ? len : index), charset);
  }
  u1t(len, charset, $super) {
    charset = charset === VOID ? get_UTF8() : charset;
    return $super === VOID ? this.t1t(len, charset) : $super.t1t.call(this, len, charset);
  }
}
class SyncAsyncStreamBase$read$slambda {
  constructor(this$0, $position, $buffer, $offset, $len) {
    this.o1u_1 = this$0;
    this.p1u_1 = $position;
    this.q1u_1 = $buffer;
    this.r1u_1 = $offset;
    this.s1u_1 = $len;
  }
  a1r($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.read.<anonymous>' call
    return this.o1u_1.d1u_1.m1u(this.p1u_1, this.q1u_1, this.r1u_1, this.s1u_1);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SyncAsyncStreamBase$write$slambda {
  constructor(this$0, $position, $buffer, $offset, $len) {
    this.t1u_1 = this$0;
    this.u1u_1 = $position;
    this.v1u_1 = $buffer;
    this.w1u_1 = $offset;
    this.x1u_1 = $len;
  }
  a1r($this$withContext, $completion) {
    this.t1u_1.d1u_1.n1u(this.u1u_1, this.v1u_1, this.w1u_1, this.x1u_1);
    return Unit_instance;
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SyncAsyncStreamBase$getLength$slambda {
  constructor(this$0) {
    this.y1u_1 = this$0;
  }
  a1r($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.getLength.<anonymous>' call
    return this.y1u_1.d1u_1.a();
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class AsyncGetLengthStream {}
function hasLength($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_hasLength__5f5ox8.bind(VOID, this), $completion);
}
function getLength($completion) {
  throw UnsupportedOperationException.q8();
}
class AsyncStreamBase {
  static z1u($box) {
    return createThis(this, $box);
  }
  a1v(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.q8();
  }
  b1v(position, buffer, offset, len, $completion) {
    throw UnsupportedOperationException.q8();
  }
  c1v($completion) {
    throw UnsupportedOperationException.q8();
  }
  m1s($completion) {
    return Unit_instance;
  }
}
class SyncAsyncStreamBase extends AsyncStreamBase {
  static j1u(sync, dispatcher) {
    dispatcher = dispatcher === VOID ? null : dispatcher;
    var $this = this.z1u();
    $this.d1u_1 = sync;
    $this.e1u_1 = dispatcher;
    return $this;
  }
  a1v(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_1.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  b1v(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_2.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  c1v($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94.bind(VOID, this), $completion);
  }
}
class toAsync$o$write$slambda {
  constructor(this$0, $buffer, $offset, $len) {
    this.g1v_1 = this$0;
    this.h1v_1 = $buffer;
    this.i1v_1 = $offset;
    this.j1v_1 = $len;
  }
  a1r($this$withContext, $completion) {
    this.g1v_1.e1v_1.t16(this.h1v_1, this.i1v_1, this.j1v_1);
    return Unit_instance;
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$close$slambda {
  constructor(this$0) {
    this.k1v_1 = this$0;
  }
  a1r($this$launch, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
    var tmp = this.k1v_1.e1v_1;
    var tmp7_safe_receiver = isInterface(tmp, AutoCloseable) ? tmp : null;
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.t6();
    }
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$1 {
  constructor($this_toAsync, $dispatcher) {
    this.f1v_1 = $dispatcher;
    this.e1v_1 = $this_toAsync;
  }
  j1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_3.bind(VOID, this, buffer, offset, len), $completion);
  }
  m1s($completion) {
    var dispatcher = this.f1v_1;
    if (!(dispatcher == null)) {
      var tmp = CoroutineScope_0(dispatcher);
      launch(tmp, VOID, VOID, toAsync$o$close$slambda_1(this));
    } else {
      // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
      var tmp_0 = this.e1v_1;
      var tmp7_safe_receiver = isInterface(tmp_0, AutoCloseable) ? tmp_0 : null;
      if (tmp7_safe_receiver == null)
        null;
      else {
        tmp7_safe_receiver.t6();
      }
    }
    return Unit_instance;
  }
}
class toAsync$o$read$slambda {
  constructor(this$0, $buffer, $offset, $len) {
    this.n1v_1 = this$0;
    this.o1v_1 = $buffer;
    this.p1v_1 = $offset;
    this.q1v_1 = $len;
  }
  a1r($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
    return this.n1v_1.l1v_1.o16(this.o1v_1, this.p1v_1, this.q1v_1);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$close$slambda_0 {
  constructor(this$0) {
    this.r1v_1 = this$0;
  }
  a1r($this$launch, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
    var tmp = this.r1v_1.l1v_1;
    var tmp4_safe_receiver = isInterface(tmp, AutoCloseable) ? tmp : null;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.t6();
    }
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$getPosition$slambda {
  constructor(this$0) {
    this.s1v_1 = this$0;
  }
  a1r($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.getPosition.<anonymous>' call
    var tmp = this.s1v_1.l1v_1;
    var tmp5_safe_receiver = isInterface(tmp, SyncPositionStream) ? tmp : null;
    return tmp5_safe_receiver == null ? null : tmp5_safe_receiver.y1s();
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class toAsync$o$getLength$slambda {
  constructor(this$0) {
    this.t1v_1 = this$0;
  }
  a1r($this$withContext, $completion) {
    // Inline function 'korlibs.io.stream.<no name provided>.getLength.<anonymous>' call
    var tmp = this.t1v_1.l1v_1;
    var tmp6_safe_receiver = isInterface(tmp, SyncLengthStream) ? tmp : null;
    return tmp6_safe_receiver == null ? null : tmp6_safe_receiver.a();
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class AsyncGetPositionStream {}
function getPosition($completion) {
  throw UnsupportedOperationException.q8();
}
class toAsync$2 {
  constructor($this_toAsync, $dispatcher) {
    this.m1v_1 = $dispatcher;
    this.l1v_1 = $this_toAsync;
  }
  l1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_2.bind(VOID, this, buffer, offset, len), $completion);
  }
  m1s($completion) {
    var dispatcher = this.m1v_1;
    if (!(dispatcher == null)) {
      var tmp = CoroutineScope_0(dispatcher);
      launch(tmp, VOID, VOID, toAsync$o$close$slambda_2(this));
    } else {
      // Inline function 'korlibs.io.stream.<no name provided>.close.<anonymous>' call
      var tmp_0 = this.l1v_1;
      var tmp4_safe_receiver = isInterface(tmp_0, AutoCloseable) ? tmp_0 : null;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.t6();
      }
    }
    return Unit_instance;
  }
  u1v($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getPosition__nbsewl.bind(VOID, this), $completion);
  }
  c1v($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94_0.bind(VOID, this), $completion);
  }
}
class SliceAsyncStreamBase extends AsyncStreamBase {
  static g1w(base, baseStart, baseEnd, closeParent) {
    var $this = this.z1u();
    $this.b1w_1 = base;
    $this.c1w_1 = baseStart;
    $this.d1w_1 = baseEnd;
    $this.e1w_1 = closeParent;
    $this.f1w_1 = $this.d1w_1.a2($this.c1w_1);
    return $this;
  }
  a1v(position, buffer, offset, len, $completion) {
    var _destruct__k2r9zo = clampPositionLen(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.ul();
    var targetLen = _destruct__k2r9zo.vl();
    return this.b1w_1.a1v(targetStartPosition, buffer, offset, targetLen, $completion);
  }
  b1v(position, buffer, offset, len, $completion) {
    var _destruct__k2r9zo = clampPositionLen(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.ul();
    var targetLen = _destruct__k2r9zo.vl();
    return this.b1w_1.b1v(targetStartPosition, buffer, offset, targetLen, $completion);
  }
  c1v($completion) {
    return this.f1w_1;
  }
  m1s($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0_0.bind(VOID, this), $completion);
  }
  toString() {
    return 'SliceAsyncStreamBase(' + toString(this.b1w_1) + ', ' + this.c1w_1.toString() + ', ' + this.d1w_1.toString() + ')';
  }
}
class BufferedStreamBase extends AsyncStreamBase {
  static o1w(base, blockSize, blocksToRead) {
    blockSize = blockSize === VOID ? 2048 : blockSize;
    blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
    var $this = this.z1u();
    $this.i1w_1 = base;
    $this.j1w_1 = blockSize;
    $this.k1w_1 = blocksToRead;
    $this.l1w_1 = imul($this.j1w_1, $this.k1w_1);
    var tmp = $this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.m1w_1 = new Int8Array([]);
    $this.n1w_1 = new Long(-1, -1);
    return $this;
  }
  a1v(position, buffer, offset, len, $completion) {
    return this.p1w(position, buffer, offset, len, $completion);
  }
  toString() {
    return 'Buffered[' + this.k1w_1 + '*' + this.j1w_1 + ']:' + toString(this.i1w_1);
  }
  p1w(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator__read__lo0dlr.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  b1v(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_4.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  c1v($completion) {
    return this.i1w_1.c1v($completion);
  }
  m1s($completion) {
    return this.i1w_1.m1s($completion);
  }
}
class MemoryAsyncStreamBase extends AsyncStreamBase {
  static k1u(data) {
    var $this = this.z1u();
    $this.f1u_1 = data;
    return $this;
  }
  static q1w(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.k1u(ByteArrayBuilder.sv(initialCapacity));
  }
  r1w() {
    return this.f1u_1.e1();
  }
  c1v($completion) {
    return toLong(this.r1w());
  }
  s1w(position) {
    if (position.z1(new Long(0, 0)) < 0)
      throw IllegalArgumentException.l('Invalid position ' + position.toString());
  }
  a1v(position, buffer, offset, len, $completion) {
    this.s1w(position);
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.r1w());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = toLong(this.r1w());
    // Inline function 'kotlin.Long.plus' call
    var b = position.a4(toLong(len));
    var end = a.z1(b) <= 0 ? a : b;
    // Inline function 'kotlin.math.max' call
    var a_0 = end.a2(position).l2();
    var actualLen = Math.max(a_0, 0);
    arraycopy(this.f1u_1.ov_1, position.l2(), buffer, offset, actualLen);
    return actualLen;
  }
  b1v(position, buffer, offset, len, $completion) {
    this.s1w(position);
    var tmp = this.f1u_1;
    // Inline function 'kotlin.math.max' call
    var a = this.f1u_1.e1();
    // Inline function 'kotlin.Long.plus' call
    var b = position.a4(toLong(len)).l2();
    var tmp$ret$1 = Math.max(a, b);
    tmp.tv(tmp$ret$1);
    arraycopy(buffer, offset, this.f1u_1.ov_1, position.l2(), len);
  }
  m1s($completion) {
    return Unit_instance;
  }
  toString() {
    return 'MemoryAsyncStreamBase(' + this.f1u_1.e1() + ')';
  }
}
class AsyncPositionLengthStream {}
function hasAvailable($completion) {
  return this.d1v($completion);
}
function getAvailable($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_getAvailable__v3o1wr_0.bind(VOID, this), $completion);
}
function eof($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_eof__cbg9jc.bind(VOID, this), $completion);
}
class AsyncStream {
  constructor(base, position, queue) {
    position = position === VOID ? new Long(0, 0) : position;
    queue = queue === VOID ? false : queue;
    this.v1v_1 = new Mixin();
    this.w1v_1 = base;
    this.x1v_1 = position;
    this.y1v_1 = queue;
    this.z1v_1 = Mutex();
    this.a1w_1 = Mutex();
  }
  r10(_set____db54di) {
    this.v1v_1.r10(_set____db54di);
  }
  s10() {
    return this.v1v_1.s10();
  }
  toString() {
    return 'AsyncStream(' + toString(this.w1v_1) + ', position=' + this.x1v_1.toString() + ')';
  }
  l1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_3.bind(VOID, this, buffer, offset, len), $completion);
  }
  j1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_6.bind(VOID, this, buffer, offset, len), $completion);
  }
  d1v($completion) {
    return this.w1v_1.d1v($completion);
  }
  h1w(value, $completion) {
    this.x1v_1 = value;
  }
  u1v($completion) {
    return this.x1v_1;
  }
  c1v($completion) {
    return this.w1v_1.c1v($completion);
  }
  m1s($completion) {
    return this.w1v_1.m1s($completion);
  }
  v1w() {
    return new AsyncStream(this.w1v_1, this.x1v_1);
  }
}
class asyncStreamWriter$1$ensureJob$2$1 {
  constructor(this$0) {
    this.e1x_1 = this$0;
  }
  j1s(buffer, offset, len, $completion) {
    return this.e1x_1.z1w_1.j1s(buffer, offset, len, $completion);
  }
  n1s(byte, $completion) {
    return this.e1x_1.z1w_1.n1s(byte, $completion);
  }
  m1s($completion) {
    return this.e1x_1.z1w_1.m1s($completion);
  }
}
class asyncStreamWriter$o$ensureJob$slambda {
  constructor($process, this$0) {
    this.x1w_1 = $process;
    this.y1w_1 = this$0;
  }
  a1r($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
  }
  ge(p1, $completion) {
    return this.a1r((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class asyncStreamWriter$1 {
  constructor($lazy, $bufferSize, $name, $process) {
    this.d1x_1 = $process;
    var tmp = this;
    var tmp_0;
    if ($lazy) {
      // Inline function 'kotlin.also' call
      var this_0 = new AsyncRingBuffer($bufferSize);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.stream.<no name provided>.deque.<anonymous>' call
      this_0.e1s_1 = $name;
      tmp_0 = this_0;
    } else {
      // Inline function 'kotlin.also' call
      var this_1 = new AsyncRingBufferChunked($bufferSize);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.stream.<no name provided>.deque.<anonymous>' call
      this_1.q1s_1 = $name;
      tmp_0 = this_1;
    }
    tmp.z1w_1 = tmp_0;
    this.a1x_1 = null;
    this.b1x_1 = null;
    this.c1x_1 = new Int8Array(1);
  }
  l1s(buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_4.bind(VOID, this, buffer, offset, len), $completion);
  }
  m1s($completion) {
    var tmp14_safe_receiver = this.b1x_1;
    if (tmp14_safe_receiver == null)
      null;
    else {
      tmp14_safe_receiver.a19();
    }
    this.b1x_1 = null;
  }
}
class SyncLengthStream {}
class SyncStreamBase {
  static l1x() {
    var $this = createThis(this);
    $this.l1u_1 = new Int8Array(16);
    return $this;
  }
  m1x() {
    return false;
  }
  m1u(position, buffer, offset, len) {
    throw UnsupportedOperationException.q8();
  }
  n1u(position, buffer, offset, len) {
    throw UnsupportedOperationException.q8();
  }
  a() {
    throw UnsupportedOperationException.q8();
  }
  t6() {
    return Unit_instance;
  }
  n1x(position) {
    return new SyncStream(this, position);
  }
  k1x(position, $super) {
    position = position === VOID ? new Long(0, 0) : position;
    return $super === VOID ? this.n1x(position) : $super.n1x.call(this, position);
  }
  o1x(position) {
    return new SyncStream(this, position);
  }
  p1x(position, $super) {
    position = position === VOID ? new Long(0, 0) : position;
    return $super === VOID ? this.o1x(position) : $super.o1x.call(this, position);
  }
}
class ReadonlySyncStreamBase extends SyncStreamBase {
  static j1x(data, offset, size) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? data.length - offset | 0 : size;
    var $this = this.l1x();
    $this.g1x_1 = data;
    $this.h1x_1 = offset;
    $this.i1x_1 = size;
    return $this;
  }
  r1w() {
    return this.i1x_1;
  }
  a() {
    return toLong(this.g1x_1.length);
  }
  s1w(position) {
    if (position.z1(new Long(0, 0)) < 0) {
      invalidOp('Invalid position ' + position.toString());
    }
  }
  m1u(position, buffer, offset, len) {
    this.s1w(position);
    var ipos = position.l2();
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.r1w());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = this.r1w();
    var b = ipos + len | 0;
    var end = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = end - ipos | 0;
    var actualLen = Math.max(a_0, 0);
    arraycopy(this.g1x_1, ipos + this.h1x_1 | 0, buffer, offset, actualLen);
    return actualLen;
  }
  t6() {
    return Unit_instance;
  }
  toString() {
    return 'ReadonlySyncStreamBase(' + this.g1x_1.length + ')';
  }
}
class MemorySyncStreamBase extends SyncStreamBase {
  static i1u(data) {
    var $this = this.l1x();
    $this.h1u_1 = data;
    return $this;
  }
  static q1x(initialCapacity) {
    initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
    return this.i1u(ByteArrayBuilder.sv(initialCapacity));
  }
  r1w() {
    return this.h1u_1.e1();
  }
  a() {
    return toLong(this.h1u_1.e1());
  }
  s1w(position) {
    if (position.z1(new Long(0, 0)) < 0)
      throw IllegalArgumentException.l('Invalid position ' + position.toString());
  }
  m1u(position, buffer, offset, len) {
    this.s1w(position);
    var ipos = position.l2();
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = until(0, this.r1w());
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), position))
      return 0;
    // Inline function 'kotlin.math.min' call
    var a = this.r1w();
    var b = ipos + len | 0;
    var end = Math.min(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = end - ipos | 0;
    var actualLen = Math.max(a_0, 0);
    arraycopy(this.h1u_1.ov_1, ipos, buffer, offset, actualLen);
    return actualLen;
  }
  n1u(position, buffer, offset, len) {
    this.s1w(position);
    var tmp = this.h1u_1;
    // Inline function 'kotlin.math.max' call
    var a = this.h1u_1.e1();
    // Inline function 'kotlin.Long.plus' call
    var b = position.a4(toLong(len)).l2();
    var tmp$ret$1 = Math.max(a, b);
    tmp.tv(tmp$ret$1);
    arraycopy(buffer, offset, this.h1u_1.ov_1, position.l2(), len);
  }
  t6() {
    return Unit_instance;
  }
  toString() {
    return 'MemorySyncStreamBase(' + this.h1u_1.e1() + ')';
  }
}
class SyncInputStream {}
function read() {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.SyncInputStream.read.<anonymous>' call
  var it = new Int8Array(1);
  return this.o16(it, 0, 1) > 0 ? it[0] & 255 : -1;
}
class SyncPositionStream {}
class SyncOutputStream {}
function write_0(byte) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it = new Int8Array(1);
  it[0] = toByte(byte);
  this.t16(it, 0, 1);
  return Unit_instance;
}
class SyncStream {
  constructor(base, position) {
    position = position === VOID ? new Long(0, 0) : position;
    this.v1t_1 = new Mixin();
    this.w1t_1 = base;
    this.x1t_1 = this.w1t_1.l1u_1;
    this.y1t_1 = this.w1t_1.m1x();
    this.z1t_1 = position;
    this.a1u_1 = position;
    this.b1u_1 = position;
    this.c1u_1 = new Long(0, 0);
  }
  r10(_set____db54di) {
    this.v1t_1.r10(_set____db54di);
  }
  s10() {
    return this.v1t_1.s10();
  }
  r1x(value) {
    if (this.y1t_1)
      this.z1t_1 = value;
    else {
      this.s1x(value);
    }
  }
  t1x() {
    return this.y1t_1 ? this.z1t_1 : this.y1s();
  }
  u1x(value) {
    if (this.y1t_1)
      this.a1u_1 = value;
    else {
      this.s1x(value);
    }
  }
  v1x() {
    return this.y1t_1 ? this.a1u_1 : this.y1s();
  }
  s1x(value) {
    var tmp;
    if (this.y1t_1) {
      this.r1x(value);
      tmp = Unit_instance;
    } else {
      this.b1u_1 = value;
      tmp = Unit_instance;
    }
    return tmp;
  }
  y1s() {
    return this.y1t_1 ? this.t1x() : this.b1u_1;
  }
  o16(buffer, offset, len) {
    var read = this.w1t_1.m1u(this.t1x(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.t1x().a4(toLong(read));
    this.r1x(tmp$ret$0);
    return read;
  }
  w1x() {
    var size = this.o16(this.x1t_1, 0, 1);
    if (size <= 0)
      return -1;
    return this.x1t_1[0] & 255;
  }
  t16(buffer, offset, len) {
    this.w1t_1.n1u(this.v1x(), buffer, offset, len);
    // Inline function 'kotlin.Long.plus' call
    var tmp$ret$0 = this.v1x().a4(toLong(len));
    this.u1x(tmp$ret$0);
  }
  u16(byte) {
    this.x1t_1[0] = toByte(byte);
    this.t16(this.x1t_1, 0, 1);
  }
  a() {
    return this.w1t_1.a();
  }
  t6() {
    return this.w1t_1.t6();
  }
  m16() {
    return this.a().a2(this.t1x());
  }
  sy() {
    return this.m16();
  }
  toString() {
    return 'SyncStream(' + toString(this.w1t_1) + ', ' + this.y1s().toString() + ')';
  }
}
class SliceSyncStreamBase extends SyncStreamBase {
  static c1y(base, baseStart, baseEnd) {
    var $this = this.l1x();
    $this.y1x_1 = base;
    $this.z1x_1 = baseStart;
    $this.a1y_1 = baseEnd;
    $this.b1y_1 = $this.a1y_1.a2($this.z1x_1);
    return $this;
  }
  m1x() {
    return this.y1x_1.m1x();
  }
  a() {
    return this.b1y_1;
  }
  m1u(position, buffer, offset, len) {
    var _destruct__k2r9zo = clampPositionLen_0(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.ul();
    var targetLen = _destruct__k2r9zo.vl();
    return this.y1x_1.m1u(targetStartPosition, buffer, offset, targetLen);
  }
  n1u(position, buffer, offset, len) {
    var _destruct__k2r9zo = clampPositionLen_0(this, position, len);
    var targetStartPosition = _destruct__k2r9zo.ul();
    var targetLen = _destruct__k2r9zo.vl();
    return this.y1x_1.n1u(targetStartPosition, buffer, offset, targetLen);
  }
  t6() {
    return Unit_instance;
  }
  toString() {
    return 'SliceAsyncStreamBase(' + toString(this.y1x_1) + ', ' + this.z1x_1.toString() + ', ' + this.a1y_1.toString() + ')';
  }
}
//endregion
function *_generator_write__x1694l($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return Unit_instance;
  if ($this.i1s_1) {
    // Inline function 'kotlin.error' call
    var message = 'Trying to write to a completed ' + $this.toString();
    throw IllegalStateException.l5(toString(message));
  }
  var tmp = $this.f1s_1.t1m($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.h1s_1.n16(buffer, offset, len);
  var tmp_0 = $this.g1s_1.p1m(Unit_instance, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_read__qih2oe($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return len;
  if ($this.h1s_1.m16() > 0) {
    return $this.h1s_1.o16(buffer, offset, len);
  }
  var tmp = $this.f1s_1.p1m(Unit_instance, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  while (!$this.i1s_1 && $this.h1s_1.m16() === 0) {
    var tmp_0 = $this.g1s_1.t1m($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  if ($this.i1s_1 && $this.h1s_1.m16() === 0)
    return -1;
  return $this.h1s_1.o16(buffer, offset, len);
}
function *_generator_close__nh2uv0($this, $completion) {
  $this.i1s_1 = true;
  var tmp = $this.g1s_1.p1m(Unit_instance, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
function *_generator_waitToWriteMore__u7wb0w($this, len, $completion) {
  if ($this.r1s_1.s16_1 > $this.p1s_1) {
    while ($this.r1s_1.s16_1 > (1 + ($this.p1s_1 / 2 | 0) | 0)) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
      var tmp = delay(tmp$ret$0, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  }
  return Unit_instance;
}
function waitToWriteMore($this, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_waitToWriteMore__u7wb0w.bind(VOID, $this, len), $completion);
}
function *_generator_write__x1694l_0($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return Unit_instance;
  if ($this.s1s_1) {
    // Inline function 'kotlin.error' call
    var message = 'Trying to write to a completed ' + $this.toString();
    throw IllegalStateException.l5(toString(message));
  }
  var tmp = waitToWriteMore($this, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.r1s_1.t16(buffer, offset, len);
  return Unit_instance;
}
function *_generator_write__x1694l_1($this, byte, $completion) {
  var tmp = waitToWriteMore($this, 1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.r1s_1.u16(byte);
  return Unit_instance;
}
function *_generator_read__qih2oe_0($this, buffer, offset, len, $completion) {
  if (len <= 0)
    return 0;
  if (offset < 0 || (offset + len | 0) > buffer.length)
    throw OutOfBoundsException.nv();
  $l$loop: while (true) {
    var out = $this.r1s_1.o16(buffer, offset, len);
    if (out <= 0 && !$this.s1s_1) {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
      var tmp = delay(tmp$ret$0, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      continue $l$loop;
    }
    return out;
  }
}
function offset($this, count) {
  var out = $this.w1s_1;
  $this.w1s_1 = $this.w1s_1 + count | 0;
  return out;
}
function openFastStream(_this__u8e3s4, offset) {
  offset = offset === VOID ? 0 : offset;
  return new FastByteArrayInputStream(_this__u8e3s4, offset);
}
function get_EMPTY_BYTE_ARRAY() {
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return EMPTY_BYTE_ARRAY;
}
var EMPTY_BYTE_ARRAY;
function toAsync(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return new toAsync$1(_this__u8e3s4, dispatcher);
}
function toAsync_0(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return new toAsync$2(_this__u8e3s4, dispatcher);
}
function toAsync_1(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  return toAsyncStream(toAsync_2(_this__u8e3s4.w1t_1, dispatcher), _this__u8e3s4.y1s());
}
function toSyncOrNull(_this__u8e3s4) {
  _init_properties_SyncAsync_ext_kt__inwu1q();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof SyncAsyncStreamBase ? _this__u8e3s4 : null;
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d1u_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    var tmp1_safe_receiver = _this__u8e3s4 instanceof MemoryAsyncStreamBase ? _this__u8e3s4 : null;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.io.stream.toSyncOrNull.<anonymous>' call
      tmp_0 = MemorySyncStreamBase.i1u(tmp1_safe_receiver.f1u_1);
    }
    tmp = tmp_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function toAsync_2(_this__u8e3s4, dispatcher) {
  dispatcher = dispatcher === VOID ? null : dispatcher;
  _init_properties_SyncAsync_ext_kt__inwu1q();
  var tmp;
  if (_this__u8e3s4 instanceof MemorySyncStreamBase) {
    tmp = MemoryAsyncStreamBase.k1u(_this__u8e3s4.h1u_1);
  } else {
    tmp = SyncAsyncStreamBase.j1u(_this__u8e3s4, dispatcher);
  }
  return tmp;
}
function *_generator_read__qih2oe_1($this, position, buffer, offset, len, $completion) {
  // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.doIo' call
  var tmp;
  if (!($this.e1u_1 == null)) {
    var tmp_0 = withContext($this.e1u_1, SyncAsyncStreamBase$read$slambda_0($this, position, buffer, offset, len), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.read.<anonymous>' call
    tmp = $this.d1u_1.m1u(position, buffer, offset, len);
  }
  return tmp;
}
function *_generator_write__x1694l_2($this, position, buffer, offset, len, $completion) {
  // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.doIo' call
  var tmp;
  if (!($this.e1u_1 == null)) {
    var tmp_0 = withContext($this.e1u_1, SyncAsyncStreamBase$write$slambda_0($this, position, buffer, offset, len), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    $this.d1u_1.n1u(position, buffer, offset, len);
    tmp = Unit_instance;
  }
  return Unit_instance;
}
function *_generator_getLength__lvva94($this, $completion) {
  // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.doIo' call
  var tmp;
  if (!($this.e1u_1 == null)) {
    var tmp_0 = withContext($this.e1u_1, SyncAsyncStreamBase$getLength$slambda_0($this), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.SyncAsyncStreamBase.getLength.<anonymous>' call
    tmp = $this.d1u_1.a();
  }
  return tmp;
}
function SyncAsyncStreamBase$read$slambda_0(this$0, $position, $buffer, $offset, $len) {
  var i = new SyncAsyncStreamBase$read$slambda(this$0, $position, $buffer, $offset, $len);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function SyncAsyncStreamBase$write$slambda_0(this$0, $position, $buffer, $offset, $len) {
  var i = new SyncAsyncStreamBase$write$slambda(this$0, $position, $buffer, $offset, $len);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function SyncAsyncStreamBase$getLength$slambda_0(this$0) {
  var i = new SyncAsyncStreamBase$getLength$slambda(this$0);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_write__x1694l_3($this, buffer, offset, len, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.f1v_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$write$slambda_0($this, buffer, offset, len), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    $this.e1v_1.t16(buffer, offset, len);
    tmp = Unit_instance;
  }
  return Unit_instance;
}
function toAsync$o$write$slambda_0(this$0, $buffer, $offset, $len) {
  var i = new toAsync$o$write$slambda(this$0, $buffer, $offset, $len);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$close$slambda_1(this$0) {
  var i = new toAsync$o$close$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_read__qih2oe_2($this, buffer, offset, len, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.m1v_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$read$slambda_0($this, buffer, offset, len), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
    tmp = $this.l1v_1.o16(buffer, offset, len);
  }
  return tmp;
}
function *_generator_getPosition__nbsewl($this, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.m1v_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$getPosition$slambda_0($this), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.getPosition.<anonymous>' call
    var tmp_1 = $this.l1v_1;
    var tmp5_safe_receiver = isInterface(tmp_1, SyncPositionStream) ? tmp_1 : null;
    tmp = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.y1s();
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var tmp_3 = getPosition.call($this, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function *_generator_getLength__lvva94_0($this, $completion) {
  // Inline function 'korlibs.io.stream.<no name provided>.doIo' call
  // Inline function 'korlibs.io.stream.doIo' call
  var dispatcher = $this.m1v_1;
  var tmp;
  if (!(dispatcher == null)) {
    var tmp_0 = withContext(dispatcher, toAsync$o$getLength$slambda_0($this), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    // Inline function 'korlibs.io.stream.<no name provided>.getLength.<anonymous>' call
    var tmp_1 = $this.l1v_1;
    var tmp6_safe_receiver = isInterface(tmp_1, SyncLengthStream) ? tmp_1 : null;
    tmp = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.a();
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    var tmp_3 = getLength.call($this, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  return tmp_2;
}
function toAsync$o$read$slambda_0(this$0, $buffer, $offset, $len) {
  var i = new toAsync$o$read$slambda(this$0, $buffer, $offset, $len);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$close$slambda_2(this$0) {
  var i = new toAsync$o$close$slambda_0(this$0);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$getPosition$slambda_0(this$0) {
  var i = new toAsync$o$getPosition$slambda(this$0);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
function toAsync$o$getLength$slambda_0(this$0) {
  var i = new toAsync$o$getLength$slambda(this$0);
  var l = function ($this$withContext, $completion) {
    return i.a1r($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var properties_initialized_SyncAsync_ext_kt_cwobuk;
function _init_properties_SyncAsync_ext_kt__inwu1q() {
  if (!properties_initialized_SyncAsync_ext_kt_cwobuk) {
    properties_initialized_SyncAsync_ext_kt_cwobuk = true;
    EMPTY_BYTE_ARRAY = new Int8Array(0);
  }
}
function *_generator_readLine__gnpvha(_this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd, $completion) {
  eol = eol === VOID ? _Char___init__impl__6a9atx(10) : eol;
  charset = charset === VOID ? get_UTF8() : charset;
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(eol);
  var tmp = readUntil(_this__u8e3s4, toByte(tmp$ret$0), limit, initialCapacity, includeEnd, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_1(tmp, charset);
}
function readLine(_this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd, $completion) {
  eol = eol === VOID ? _Char___init__impl__6a9atx(10) : eol;
  charset = charset === VOID ? get_UTF8() : charset;
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readLine__gnpvha.bind(VOID, _this__u8e3s4, eol, charset, limit, initialCapacity, includeEnd), $completion);
}
function *_generator_readU16BE__ml3dd9(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var tmp = _this__u8e3s4.l1s(it, 0, 2, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.l5(toString(message));
  }
  // Inline function 'korlibs.io.stream.readU16BE.<anonymous>' call
  return getU16BE(it, 0);
}
function readU16BE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16BE__ml3dd9.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readS32BE__lo15th(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var tmp = _this__u8e3s4.l1s(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.l5(toString(message));
  }
  // Inline function 'korlibs.io.stream.readS32BE.<anonymous>' call
  return getS32BE(it, 0);
}
function readS32BE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32BE__lo15th.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readString__6uahun(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  var tmp = readBytesExact(_this__u8e3s4, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return toString_1(tmp, charset);
}
function readString(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readString__6uahun.bind(VOID, _this__u8e3s4, len, charset), $completion);
}
function *_generator_readU16__9pf7bk(_this__u8e3s4, endian, $completion) {
  var tmp;
  if (endian.equals(Endian_LITTLE_ENDIAN_getInstance())) {
    var tmp_0 = readU16LE(_this__u8e3s4, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = readU16BE(_this__u8e3s4, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function readU16(_this__u8e3s4, endian, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16__9pf7bk.bind(VOID, _this__u8e3s4, endian), $completion);
}
function *_generator_readS32__9pdyqg(_this__u8e3s4, endian, $completion) {
  var tmp;
  if (endian.equals(Endian_LITTLE_ENDIAN_getInstance())) {
    var tmp_0 = readS32LE(_this__u8e3s4, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = readS32BE(_this__u8e3s4, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function readS32(_this__u8e3s4, endian, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32__9pdyqg.bind(VOID, _this__u8e3s4, endian), $completion);
}
function *_generator_readStringz__10au0x(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  var tmp = readBytesExact(_this__u8e3s4, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var res = tmp;
  var index = indexOf(res, 0);
  return toString_1(copyOf(res, index < 0 ? len : index), charset);
}
function readStringz(_this__u8e3s4, len, charset, $completion) {
  charset = charset === VOID ? get_UTF8() : charset;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readStringz__10au0x.bind(VOID, _this__u8e3s4, len, charset), $completion);
}
function *_generator_readS16LE__ln0bzt(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var tmp = _this__u8e3s4.l1s(it, 0, 2, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.l5(toString(message));
  }
  // Inline function 'korlibs.io.stream.readS16LE.<anonymous>' call
  return getS16LE(it, 0);
}
function readS16LE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS16LE__ln0bzt.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readS32LE__lo1d8f(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var tmp = _this__u8e3s4.l1s(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.l5(toString(message));
  }
  // Inline function 'korlibs.io.stream.readS32LE.<anonymous>' call
  return getS32LE(it, 0);
}
function readS32LE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readS32LE__lo1d8f.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readU32LE__mm4m0t(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(4);
  var tmp = _this__u8e3s4.l1s(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 4)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 4 + ' but read=' + read;
    throw IllegalStateException.l5(toString(message));
  }
  // Inline function 'korlibs.io.stream.readU32LE.<anonymous>' call
  return getU32LE(it, 0);
}
function readU32LE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU32LE__mm4m0t.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_readUntil__njr8lo(_this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp, $completion) {
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  temp = temp === VOID ? new Int8Array(1) : temp;
  var out = ByteArrayBuilder.sv(initialCapacity);
  try {
    $l$loop_0: while (true) {
      var tmp = readExact(_this__u8e3s4, temp, 0, 1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var c = temp[0];
      if (c === endByte) {
        if (includeEnd) {
          // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
          out.wv(c);
        }
        break $l$loop_0;
      }
      // Inline function 'korlibs.memory.ByteArrayBuilder.append' call
      out.wv(c);
      if (out.e1() >= limit)
        break $l$loop_0;
    }
  } catch ($p) {
    if ($p instanceof EOFException) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return out.xv();
}
function readUntil(_this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp, $completion) {
  limit = limit === VOID ? 2147483647 : limit;
  initialCapacity = initialCapacity === VOID ? 4096 : initialCapacity;
  includeEnd = includeEnd === VOID ? false : includeEnd;
  temp = temp === VOID ? new Int8Array(1) : temp;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readUntil__njr8lo.bind(VOID, _this__u8e3s4, endByte, limit, initialCapacity, includeEnd, temp), $completion);
}
function *_generator_readU16LE__ml3ks7(_this__u8e3s4, $completion) {
  // Inline function 'korlibs.io.stream.readSmallTempExact' call
  var it = new Int8Array(2);
  var tmp = _this__u8e3s4.l1s(it, 0, 2, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (!(read === 2)) {
    // Inline function 'kotlin.error' call
    var message = "Couldn't read exact size=" + 2 + ' but read=' + read;
    throw IllegalStateException.l5(toString(message));
  }
  // Inline function 'korlibs.io.stream.readU16LE.<anonymous>' call
  return getU16LE(it, 0);
}
function readU16LE(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readU16LE__ml3ks7.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_hasAvailable__erwk13(_this__u8e3s4, $completion) {
  var tmp = getAvailable_0(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.z1(new Long(0, 0)) > 0;
}
function hasAvailable_0(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_hasAvailable__erwk13.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_getAvailable__v3o1wr(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.c1v($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _this__u8e3s4.u1v($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp.a2(tmp_0);
}
function getAvailable_0(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_getAvailable__v3o1wr.bind(VOID, _this__u8e3s4), $completion);
}
function write8(_this__u8e3s4, v, $completion) {
  return _this__u8e3s4.n1s(v, $completion);
}
function *_generator_write16LE__jployf(_this__u8e3s4, v, $completion) {
  // Inline function 'korlibs.io.stream.smallBytesAlloc' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it = new Int8Array(16);
  set16LE(it, 0, v);
  var tmp = _this__u8e3s4.j1s(it, 0, 2, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function write16LE(_this__u8e3s4, v, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_write16LE__jployf.bind(VOID, _this__u8e3s4, v), $completion);
}
function writeBytes(_this__u8e3s4, data, $completion) {
  return _this__u8e3s4.j1s(data, 0, data.length, $completion);
}
function *_generator_write32LE__jqmq71(_this__u8e3s4, v, $completion) {
  // Inline function 'korlibs.io.stream.smallBytesAlloc' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it = new Int8Array(16);
  set32LE(it, 0, v);
  var tmp = _this__u8e3s4.j1s(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function write32LE(_this__u8e3s4, v, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_write32LE__jqmq71.bind(VOID, _this__u8e3s4, v), $completion);
}
function *_generator_write32BE__jqmis3(_this__u8e3s4, v, $completion) {
  // Inline function 'korlibs.io.stream.smallBytesAlloc' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it = new Int8Array(16);
  set32BE(it, 0, v);
  var tmp = _this__u8e3s4.j1s(it, 0, 4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function write32BE(_this__u8e3s4, v, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_write32BE__jqmis3.bind(VOID, _this__u8e3s4, v), $completion);
}
function skipToAlign(_this__u8e3s4, alignment, offset) {
  var tmp = _this__u8e3s4;
  // Inline function 'kotlin.Long.minus' call
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = _this__u8e3s4.x1v_1.a4(toLong(offset));
  tmp.x1v_1 = nextAlignedTo(tmp$ret$0, toLong(alignment)).a2(toLong(offset));
}
function *_generator_readBytes__epy2u7(_this__u8e3s4, position, count, $completion) {
  var out = new Int8Array(count);
  var tmp = _this__u8e3s4.a1v(position, out, 0, out.length, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var readLen = tmp;
  return copyOf(out, readLen);
}
function readBytes(_this__u8e3s4, position, count, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytes__epy2u7.bind(VOID, _this__u8e3s4, position, count), $completion);
}
function *_generator_sliceStart__7mxlrc(_this__u8e3s4, start, closeParent, $completion) {
  start = start === VOID ? new Long(0, 0) : start;
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp = _this__u8e3s4.c1v($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = sliceWithBounds(_this__u8e3s4, start, tmp, closeParent, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function sliceStart(_this__u8e3s4, start, closeParent, $completion) {
  start = start === VOID ? new Long(0, 0) : start;
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceStart__7mxlrc.bind(VOID, _this__u8e3s4, start, closeParent), $completion);
}
function readStream(_this__u8e3s4, length, $completion) {
  return readSlice(_this__u8e3s4, toLong(length), $completion);
}
function *_generator_sliceHere__xy500i(_this__u8e3s4, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp = _this__u8e3s4.x1v_1;
  var tmp_0 = _this__u8e3s4.c1v($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = sliceWithSize(_this__u8e3s4, tmp, tmp_0, closeParent, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function sliceHere(_this__u8e3s4, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceHere__xy500i.bind(VOID, _this__u8e3s4, closeParent), $completion);
}
function *_generator_sliceWithBounds__ahw9dz(_this__u8e3s4, start, end, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  var tmp;
  var tmp_0 = _this__u8e3s4.d1v($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = _this__u8e3s4.c1v($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  } else {
    tmp = end;
  }
  var rlen = tmp;
  var len = rlen.z1(new Long(0, 0)) >= 0 ? rlen : end;
  var clampedStart = coerceIn_0(start, new Long(0, 0), len);
  var clampedEnd = coerceIn_0(end, new Long(0, 0), len);
  var base = _this__u8e3s4.w1v_1;
  var tmp_2;
  if (base instanceof SliceAsyncStreamBase) {
    tmp_2 = SliceAsyncStreamBase.g1w(base.b1w_1, base.c1w_1.a4(clampedStart), base.c1w_1.a4(clampedEnd), closeParent);
  } else {
    tmp_2 = SliceAsyncStreamBase.g1w(_this__u8e3s4.w1v_1, clampedStart, clampedEnd, closeParent);
  }
  return toAsyncStream(tmp_2);
}
function sliceWithBounds(_this__u8e3s4, start, end, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sliceWithBounds__ahw9dz.bind(VOID, _this__u8e3s4, start, end, closeParent), $completion);
}
function *_generator_readSlice__mkd95k(_this__u8e3s4, length, $completion) {
  var tmp = _this__u8e3s4.u1v($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var start = tmp;
  var tmp_0 = sliceWithSize(_this__u8e3s4, start, length, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var out = tmp_0;
  var tmp_1 = _this__u8e3s4.h1w(start.a4(length), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return out;
}
function readSlice(_this__u8e3s4, length, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readSlice__mkd95k.bind(VOID, _this__u8e3s4, length), $completion);
}
function sliceWithSize(_this__u8e3s4, start, length, closeParent, $completion) {
  closeParent = closeParent === VOID ? false : closeParent;
  return sliceWithBounds(_this__u8e3s4, start, start.a4(length), closeParent, $completion);
}
function clampPosition($this, position) {
  return coerceIn_0(position, $this.c1w_1, $this.d1w_1);
}
function clampPositionLen($this, position, len) {
  if (position.z1(new Long(0, 0)) < 0)
    throw IllegalArgumentException.l('Invalid position');
  var targetStartPosition = clampPosition($this, $this.c1w_1.a4(position));
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = targetStartPosition.a4(toLong(len));
  var targetEndPosition = clampPosition($this, tmp$ret$0);
  var targetLen = targetEndPosition.a2(targetStartPosition).l2();
  return new Pair(targetStartPosition, targetLen);
}
function *_generator_close__nh2uv0_0($this, $completion) {
  if ($this.e1w_1) {
    var tmp = $this.b1w_1.m1s($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function buffered(_this__u8e3s4, blockSize, blocksToRead) {
  blockSize = blockSize === VOID ? 2048 : blockSize;
  blocksToRead = blocksToRead === VOID ? 16 : blocksToRead;
  return toAsyncStream(BufferedStreamBase.o1w(_this__u8e3s4.w1v_1, blockSize, blocksToRead), _this__u8e3s4.x1v_1);
}
function *_generator__read__lo0dlr($this, position, buffer, offset, len, $completion) {
  var tmp;
  var tmp_0 = $this.i1w_1.d1v($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = $this.i1w_1.c1v($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = position.z1(tmp_1) >= 0;
  } else {
    tmp = false;
  }
  if (tmp)
    return -1;
  // Inline function 'kotlin.Long.div' call
  var other = $this.l1w_1;
  var sector = position.c4(toLong(other));
  if (!$this.n1w_1.equals(sector)) {
    // Inline function 'kotlin.Long.times' call
    var other_0 = $this.l1w_1;
    var pos = sector.b4(toLong(other_0));
    var tmp_2;
    var tmp_3 = $this.i1w_1.d1v($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    if (tmp_3) {
      // Inline function 'kotlin.comparisons.minOf' call
      var a = toLong($this.l1w_1);
      var tmp_4 = $this.i1w_1.c1v($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var b = tmp_4.a2(pos);
      tmp_2 = (a.z1(b) <= 0 ? a : b).l2();
    } else {
      tmp_2 = $this.l1w_1;
    }
    var len_0 = tmp_2;
    var tmp_5 = $this;
    var tmp_6 = readBytes($this.i1w_1, pos, len_0, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    tmp_5.m1w_1 = tmp_6;
    $this.n1w_1 = sector;
  }
  // Inline function 'kotlin.Long.rem' call
  var other_1 = $this.l1w_1;
  var soffset = position.d4(toLong(other_1)).l2();
  var available = $this.m1w_1.length - soffset | 0;
  // Inline function 'kotlin.math.min' call
  var toRead = Math.min(available, len);
  arraycopy($this.m1w_1, soffset, buffer, offset, toRead);
  return toRead;
}
function *_generator_write__x1694l_4($this, position, buffer, offset, len, $completion) {
  var tmp = $this.i1w_1.b1v(position, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function openAsync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return toAsyncStream(MemoryAsyncStreamBase.k1u(ByteArrayBuilder.rv(_this__u8e3s4, VOID, true)), new Long(0, 0));
}
function *_generator_write__x1694l_5($this, byte, $completion) {
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  var it = new Int8Array(1);
  it[0] = toByte(byte);
  var tmp = $this.j1s(it, 0, 1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_copyTo__iu4794(_this__u8e3s4, target, chunkSize, $completion) {
  chunkSize = chunkSize === VOID ? 8388608 : chunkSize;
  var tmp;
  if (_this__u8e3s4 instanceof AsyncStream) {
    var tmp_0 = _this__u8e3s4.w1v_1;
    tmp = tmp_0 instanceof MemoryAsyncStreamBase;
  } else {
    tmp = false;
  }
  if (tmp) {
    var tmp_1 = _this__u8e3s4.w1v_1;
    var base = tmp_1 instanceof MemoryAsyncStreamBase ? tmp_1 : THROW_CCE();
    var tmp_2 = target.j1s(base.f1u_1.ov_1, _this__u8e3s4.x1v_1.l2(), base.r1w() - _this__u8e3s4.x1v_1.l2() | 0, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    return toLong(base.r1w());
  }
  var tmp_3;
  if (isInterface(_this__u8e3s4, AsyncGetLengthStream)) {
    // Inline function 'kotlin.math.min' call
    var tmp_4 = _this__u8e3s4.c1v($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var a = tmp_4;
    var b = toLong(chunkSize);
    tmp_3 = (a.z1(b) <= 0 ? a : b).l2();
  } else {
    tmp_3 = chunkSize;
  }
  var rchunkSize = tmp_3;
  var totalCount = new Long(0, 0);
  // Inline function 'korlibs.io.stream.consume' call
  var temp = new Int8Array(rchunkSize);
  try {
    $l$loop: while (true) {
      var tmp_5 = _this__u8e3s4.l1s(temp, 0, temp.length, $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      var read = tmp_5;
      if (read <= 0)
        break $l$loop;
      // Inline function 'korlibs.io.stream.copyTo.<anonymous>' call
      var tmp_6 = target.j1s(temp, 0, read, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      // Inline function 'kotlin.Long.plus' call
      totalCount = totalCount.a4(toLong(read));
    }
  }finally {
    if (false) {
      var tmp_7 = _this__u8e3s4.m1s($completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    }
  }
  return totalCount;
}
function copyTo(_this__u8e3s4, target, chunkSize, $completion) {
  chunkSize = chunkSize === VOID ? 8388608 : chunkSize;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_copyTo__iu4794.bind(VOID, _this__u8e3s4, target, chunkSize), $completion);
}
function *_generator_readBytesExact__9z65vi(_this__u8e3s4, len, $completion) {
  // Inline function 'kotlin.apply' call
  var this_0 = new Int8Array(len);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.readBytesExact.<anonymous>' call
  var tmp = readExact(_this__u8e3s4, this_0, 0, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return this_0;
}
function readBytesExact(_this__u8e3s4, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesExact__9z65vi.bind(VOID, _this__u8e3s4, len), $completion);
}
function *_generator_hasLength__5f5ox8($this, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.c1v($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0.z1(new Long(0, 0)) >= 0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof UnsupportedOperationException) {
      var t = $p;
      tmp_1 = false;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_readAll__9p3omh(_this__u8e3s4, $completion) {
  var tmp;
  try {
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (isInterface(_this__u8e3s4, AsyncGetPositionStream)) {
      tmp_2 = isInterface(_this__u8e3s4, AsyncGetLengthStream);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var tmp_3 = _this__u8e3s4.d1v($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      tmp_1 = tmp_3;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      var tmp_4 = _this__u8e3s4.c1v($completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      var tmp_5 = _this__u8e3s4.u1v($completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      var available = tmp_4.a2(tmp_5);
      var tmp_6 = readBytesExact(_this__u8e3s4, available.l2(), $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      tmp_0 = tmp_6;
    } else {
      var tmp_7;
      if (_this__u8e3s4 instanceof AsyncStream) {
        var tmp_8 = _this__u8e3s4.t1w($completion);
        if (tmp_8 === get_COROUTINE_SUSPENDED())
          tmp_8 = yield tmp_8;
        tmp_7 = tmp_8;
      } else {
        tmp_7 = false;
      }
      if (tmp_7) {
        var tmp_9 = _this__u8e3s4.u1w($completion);
        if (tmp_9 === get_COROUTINE_SUSPENDED())
          tmp_9 = yield tmp_9;
        var available_0 = tmp_9.l2();
        var tmp_10 = readBytesExact(_this__u8e3s4, available_0, $completion);
        if (tmp_10 === get_COROUTINE_SUSPENDED())
          tmp_10 = yield tmp_10;
        tmp_0 = tmp_10;
      } else {
        var out = ByteArrayBuilder.sv();
        // Inline function 'korlibs.io.stream.readChunks' call
        var temp = new Int8Array(1024);
        $l$loop: while (true) {
          var tmp_11 = _this__u8e3s4.l1s(temp, 0, temp.length, $completion);
          if (tmp_11 === get_COROUTINE_SUSPENDED())
            tmp_11 = yield tmp_11;
          var r = tmp_11;
          if (r <= 0)
            break $l$loop;
          // Inline function 'korlibs.io.stream.readAll.<anonymous>' call
          out.uv(temp, 0, r);
        }
        tmp_0 = out.xv();
      }
    }
    tmp = tmp_0;
  }finally {
    var tmp_12 = _this__u8e3s4.m1s($completion);
    if (tmp_12 === get_COROUTINE_SUSPENDED())
      tmp_12 = yield tmp_12;
  }
  return tmp;
}
function readAll(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readAll__9p3omh.bind(VOID, _this__u8e3s4), $completion);
}
function *_generator_read__qih2oe_3($this, buffer, offset, len, $completion) {
  var tmp;
  if ($this.y1v_1) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = $this.z1v_1;
    var tmp_0 = this_0.m1p(null, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1;
    try {
      // Inline function 'korlibs.io.stream.AsyncStream.read.<anonymous>' call
      var tmp_2 = readInternal($this, buffer, offset, len, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1 = tmp_2;
    }finally {
      this_0.x1o(null);
    }
    tmp = tmp_1;
  } else {
    var tmp_3 = readInternal($this, buffer, offset, len, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp = tmp_3;
  }
  return tmp;
}
function *_generator_write__x1694l_6($this, buffer, offset, len, $completion) {
  if ($this.y1v_1) {
    // Inline function 'kotlinx.coroutines.sync.withLock' call
    var this_0 = $this.a1w_1;
    var tmp = this_0.m1p(null, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0;
    try {
      var tmp_1 = writeInternal($this, buffer, offset, len, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = Unit_instance;
    }finally {
      this_0.x1o(null);
    }
  } else {
    var tmp_2 = writeInternal($this, buffer, offset, len, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
  }
  return Unit_instance;
}
function *_generator_readInternal__sbpouj($this, buffer, offset, len, $completion) {
  var tmp = $this.w1v_1.a1v($this.x1v_1, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var read = tmp;
  if (read >= 0) {
    var tmp_0 = $this;
    // Inline function 'kotlin.Long.plus' call
    tmp_0.x1v_1 = $this.x1v_1.a4(toLong(read));
  }
  return read;
}
function readInternal($this, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readInternal__sbpouj.bind(VOID, $this, buffer, offset, len), $completion);
}
function *_generator_writeInternal__u35gg8($this, buffer, offset, len, $completion) {
  var tmp = $this.w1v_1.b1v($this.x1v_1, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this;
  // Inline function 'kotlin.Long.plus' call
  tmp_0.x1v_1 = $this.x1v_1.a4(toLong(len));
  return Unit_instance;
}
function writeInternal($this, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_writeInternal__u35gg8.bind(VOID, $this, buffer, offset, len), $completion);
}
function toAsyncStream(_this__u8e3s4, position) {
  position = position === VOID ? new Long(0, 0) : position;
  return new AsyncStream(_this__u8e3s4, position);
}
function *_generator_readBytesUpTo__nh3xxl(_this__u8e3s4, len, $completion) {
  var BYTES_TEMP_SIZE = 4096;
  if (len <= BYTES_TEMP_SIZE) {
    var tmp = readBytesUpToCopy(_this__u8e3s4, new Int8Array(len), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    return tmp;
  }
  if (isInterface(_this__u8e3s4, AsyncPositionLengthStream)) {
    // Inline function 'kotlin.math.min' call
    var tmp_0 = _this__u8e3s4.u1w($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var b = toIntClamp(tmp_0);
    var tmp$ret$0 = Math.min(len, b);
    var tmp_1 = readBytesUpToCopy(_this__u8e3s4, new Int8Array(tmp$ret$0), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    return tmp_1;
  }
  var pending = len;
  var temp = new Int8Array(BYTES_TEMP_SIZE);
  var bout = ByteArrayBuilder.sv();
  $l$loop: while (pending > 0) {
    // Inline function 'kotlin.math.min' call
    var a = temp.length;
    var b_0 = pending;
    var tmp$ret$1 = Math.min(a, b_0);
    var tmp_2 = _this__u8e3s4.l1s(temp, 0, tmp$ret$1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var read = tmp_2;
    if (read <= 0)
      break $l$loop;
    bout.uv(temp, 0, read);
    pending = pending - read | 0;
  }
  return bout.xv();
}
function readBytesUpTo(_this__u8e3s4, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpTo__nh3xxl.bind(VOID, _this__u8e3s4, len), $completion);
}
function *_generator_readBytesUpTo__nh3xxl_0(_this__u8e3s4, out, offset, len, $completion) {
  var total = 0;
  var pending = len;
  var offset_0 = offset;
  $l$loop: while (true) {
    var tmp = _this__u8e3s4.l1s(out, offset_0, pending, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var result = tmp;
    if (result <= 0)
      break $l$loop;
    offset_0 = offset_0 + result | 0;
    pending = pending - result | 0;
    total = total + result | 0;
  }
  return total;
}
function readBytesUpTo_0(_this__u8e3s4, out, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpTo__nh3xxl_0.bind(VOID, _this__u8e3s4, out, offset, len), $completion);
}
function *_generator_readExact__g46z7v(_this__u8e3s4, buffer, offset, len, $completion) {
  var remaining = len;
  var coffset = offset;
  var reader = _this__u8e3s4;
  $l$loop: while (remaining > 0) {
    var tmp = reader.l1s(buffer, coffset, remaining, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var read = tmp;
    if (read < 0)
      break $l$loop;
    if (read === 0)
      throw EOFException.sx('Not enough data. Expected=' + len + ', Read=' + (len - remaining | 0) + ', Remaining=' + remaining);
    coffset = coffset + read | 0;
    remaining = remaining - read | 0;
  }
  return Unit_instance;
}
function readExact(_this__u8e3s4, buffer, offset, len, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readExact__g46z7v.bind(VOID, _this__u8e3s4, buffer, offset, len), $completion);
}
function *_generator_getAvailable__v3o1wr_0($this, $completion) {
  var tmp = $this.c1v($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.u1v($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp.a2(tmp_0);
}
function *_generator_eof__cbg9jc($this, $completion) {
  var tmp;
  var tmp_0 = $this.t1w($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    var tmp_1 = $this.u1w($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1.z1(new Long(0, 0)) <= 0;
  } else {
    tmp = false;
  }
  return tmp;
}
function *_generator_readBytesUpToCopy__bi3svg(_this__u8e3s4, out, $completion) {
  var tmp = readBytesUpTo_0(_this__u8e3s4, out, 0, out.length, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var pos = tmp;
  return out.length === pos ? out : copyOf(out, pos);
}
function readBytesUpToCopy(_this__u8e3s4, out, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytesUpToCopy__bi3svg.bind(VOID, _this__u8e3s4, out), $completion);
}
function asyncStreamWriter(bufferSize, name, lazy, process, $completion) {
  bufferSize = bufferSize === VOID ? 8388608 : bufferSize;
  name = name === VOID ? null : name;
  lazy = lazy === VOID ? false : lazy;
  return new asyncStreamWriter$1(lazy, bufferSize, name, process);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  try {
    var tmp = $this.x1w_1(new asyncStreamWriter$1$ensureJob$2$1($this.y1w_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      $this.y1w_1.a1x_1 = e;
      printStackTrace(e);
    } else {
      throw $p;
    }
  }
  finally {
    var tmp_0 = $this.y1w_1.z1w_1.m1s($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
function checkException($this) {
  if (!($this.a1x_1 == null))
    throw RuntimeException.oe('Error in asyncStreamWriter : ' + toString_0($this.a1x_1), ensureNotNull($this.a1x_1));
}
function ensureJob($this, $completion) {
  if (!($this.b1x_1 == null))
    return Unit_instance;
  var tmp = $this;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.cd();
  var tmp_0 = CoroutineScope_0(tmp$ret$0);
  tmp.b1x_1 = launch(tmp_0, VOID, VOID, asyncStreamWriter$o$ensureJob$slambda_0($this.d1x_1, $this));
}
function *_generator_read__qih2oe_4($this, buffer, offset, len, $completion) {
  var tmp = ensureJob($this, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  checkException($this);
  // Inline function 'kotlin.also' call
  var tmp_0 = $this.z1w_1.l1s(buffer, offset, len, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.<no name provided>.read.<anonymous>' call
  return tmp_0;
}
function asyncStreamWriter$o$ensureJob$slambda_0($process, this$0) {
  var i = new asyncStreamWriter$o$ensureJob$slambda($process, this$0);
  var l = function ($this$launch, $completion) {
    return i.a1r($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function toSyncStream(_this__u8e3s4) {
  return ReadonlySyncStreamBase.j1x(_this__u8e3s4.t1s_1, _this__u8e3s4.u1s_1, _this__u8e3s4.v1s_1 - _this__u8e3s4.u1s_1 | 0).k1x();
}
function openSync(_this__u8e3s4, mode) {
  mode = mode === VOID ? 'r' : mode;
  return MemorySyncStreamBase.i1u(ByteArrayBuilder.rv(_this__u8e3s4)).o1x(new Long(0, 0));
}
function MemorySyncStream(data) {
  data = data === VOID ? get_EMPTY_BYTE_ARRAY() : data;
  return MemorySyncStreamBase.i1u(ByteArrayBuilder.rv(data)).p1x();
}
function MemorySyncStream_0(data) {
  return MemorySyncStreamBase.i1u(data).p1x();
}
function readString_0(_this__u8e3s4, len) {
  return decodeToString(readBytes_0(_this__u8e3s4, len));
}
function readS32BE_0(_this__u8e3s4) {
  return readU8(_this__u8e3s4) << 24 | readU8(_this__u8e3s4) << 16 | readU8(_this__u8e3s4) << 8 | readU8(_this__u8e3s4);
}
function readStringz_0(_this__u8e3s4, len) {
  var res = readBytes_0(_this__u8e3s4, len);
  var index = indexOf(res, 0);
  return decodeToString(copyOf(res, index < 0 ? len : index));
}
function readU8(_this__u8e3s4) {
  return _this__u8e3s4.w1x();
}
function readBytes_0(_this__u8e3s4, len) {
  var bytes = new Int8Array(len);
  var out = _this__u8e3s4.o16(bytes, 0, len);
  return !(out === len) ? copyOf(bytes, out) : bytes;
}
function readString_1(_this__u8e3s4, len, charset) {
  charset = charset === VOID ? get_UTF8() : charset;
  return toString_1(readBytes_0(_this__u8e3s4, len), charset);
}
function write8_0(_this__u8e3s4, v) {
  return _this__u8e3s4.u16(v);
}
function write32BE_0(_this__u8e3s4, v) {
  write8_0(_this__u8e3s4, (v >>> 24 | 0) & 255);
  write8_0(_this__u8e3s4, (v >>> 16 | 0) & 255);
  write8_0(_this__u8e3s4, (v >>> 8 | 0) & 255);
  write8_0(_this__u8e3s4, v & 255);
}
function writeBytes_0(_this__u8e3s4, data) {
  return _this__u8e3s4.t16(data, 0, data.length);
}
function get_eof(_this__u8e3s4) {
  return _this__u8e3s4.sy().z1(new Long(0, 0)) <= 0;
}
function readAll_0(_this__u8e3s4) {
  return readBytes_0(_this__u8e3s4, _this__u8e3s4.sy().l2());
}
function readStream_0(_this__u8e3s4, length) {
  return readSlice_0(_this__u8e3s4, length);
}
function sliceStart_0(_this__u8e3s4, start) {
  start = start === VOID ? new Long(0, 0) : start;
  return sliceWithBounds_0(_this__u8e3s4, start, _this__u8e3s4.a());
}
function readSlice_0(_this__u8e3s4, length) {
  // Inline function 'kotlin.apply' call
  var this_0 = sliceWithSize_0(_this__u8e3s4, _this__u8e3s4.y1s(), length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.stream.readSlice.<anonymous>' call
  _this__u8e3s4.s1x(_this__u8e3s4.y1s().a4(length));
  return this_0;
}
function sliceWithBounds_0(_this__u8e3s4, start, end) {
  var len = _this__u8e3s4.a();
  var clampedStart = coerceIn_0(start, new Long(0, 0), len);
  var clampedEnd = coerceIn_0(end, new Long(0, 0), len);
  var base = _this__u8e3s4.w1t_1;
  if (base instanceof SliceSyncStreamBase) {
    return SliceSyncStreamBase.c1y(base.y1x_1, base.z1x_1.a4(clampedStart), base.z1x_1.a4(clampedEnd)).p1x();
  } else {
    return SliceSyncStreamBase.c1y(base, clampedStart, clampedEnd).p1x();
  }
}
function sliceWithSize_0(_this__u8e3s4, position, length) {
  return sliceWithBounds_0(_this__u8e3s4, position, position.a4(length));
}
function clampPosition_0($this, position) {
  return coerceIn_0(position, $this.z1x_1, $this.a1y_1);
}
function clampPositionLen_0($this, position, len) {
  if (position.z1(new Long(0, 0)) < 0)
    throw IllegalArgumentException.l('Invalid position');
  var targetStartPosition = clampPosition_0($this, $this.z1x_1.a4(position));
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = targetStartPosition.a4(toLong(len));
  var targetEndPosition = clampPosition_0($this, tmp$ret$0);
  var targetLen = targetEndPosition.a2(targetStartPosition).l2();
  return new Pair(targetStartPosition, targetLen);
}
//region block: post-declaration
initMetadataForInterface(AsyncOutputStream, 'AsyncOutputStream', VOID, VOID, VOID, [3, 1, 0]);
protoOf(AsyncRingBuffer).k1s = write$default;
protoOf(AsyncRingBuffer).n1s = write;
initMetadataForClass(AsyncRingBuffer, 'AsyncRingBuffer', AsyncRingBuffer, VOID, [AsyncOutputStream], [3, 0, 1]);
initMetadataForCompanion(Companion);
protoOf(AsyncRingBufferChunked).k1s = write$default;
initMetadataForClass(AsyncRingBufferChunked, 'AsyncRingBufferChunked', AsyncRingBufferChunked, VOID, [AsyncOutputStream], [1, 3, 0]);
initMetadataForClass(FastByteArrayInputStream, 'FastByteArrayInputStream');
initMetadataForLambda(SyncAsyncStreamBase$read$slambda, VOID, VOID, [1]);
initMetadataForLambda(SyncAsyncStreamBase$write$slambda, VOID, VOID, [1]);
initMetadataForLambda(SyncAsyncStreamBase$getLength$slambda, VOID, VOID, [1]);
initMetadataForInterface(AsyncGetLengthStream, 'AsyncGetLengthStream', VOID, VOID, VOID, [0]);
protoOf(AsyncStreamBase).d1v = hasLength;
initMetadataForClass(AsyncStreamBase, 'AsyncStreamBase', AsyncStreamBase.z1u, VOID, [AsyncGetLengthStream], [4, 1, 0]);
initMetadataForClass(SyncAsyncStreamBase, 'SyncAsyncStreamBase', VOID, VOID, VOID, [1, 4, 0]);
initMetadataForLambda(toAsync$o$write$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$close$slambda, VOID, VOID, [1]);
protoOf(toAsync$1).k1s = write$default;
protoOf(toAsync$1).n1s = write;
initMetadataForClass(toAsync$1, VOID, VOID, VOID, [AsyncOutputStream], [1, 3, 0]);
initMetadataForLambda(toAsync$o$read$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$close$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$getPosition$slambda, VOID, VOID, [1]);
initMetadataForLambda(toAsync$o$getLength$slambda, VOID, VOID, [1]);
initMetadataForInterface(AsyncGetPositionStream, 'AsyncGetPositionStream', VOID, VOID, VOID, [0]);
protoOf(toAsync$2).d1v = hasLength;
initMetadataForClass(toAsync$2, VOID, VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [1, 3, 0]);
initMetadataForClass(SliceAsyncStreamBase, 'SliceAsyncStreamBase', VOID, VOID, VOID, [4, 0, 1]);
initMetadataForClass(BufferedStreamBase, 'BufferedStreamBase', VOID, VOID, VOID, [4, 1, 0]);
initMetadataForClass(MemoryAsyncStreamBase, 'MemoryAsyncStreamBase', MemoryAsyncStreamBase.q1w, VOID, VOID, [1, 0, 4]);
initMetadataForInterface(AsyncPositionLengthStream, 'AsyncPositionLengthStream', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream], [0, 1]);
protoOf(AsyncStream).k1s = write$default;
protoOf(AsyncStream).n1s = write;
protoOf(AsyncStream).t1w = hasAvailable;
protoOf(AsyncStream).u1w = getAvailable;
protoOf(AsyncStream).w1w = eof;
initMetadataForClass(AsyncStream, 'AsyncStream', VOID, VOID, [AsyncGetPositionStream, AsyncGetLengthStream, AsyncOutputStream, AsyncPositionLengthStream], [3, 0, 1]);
protoOf(asyncStreamWriter$1$ensureJob$2$1).k1s = write$default;
initMetadataForClass(asyncStreamWriter$1$ensureJob$2$1, VOID, VOID, VOID, [AsyncOutputStream], [3, 1, 0]);
initMetadataForLambda(asyncStreamWriter$o$ensureJob$slambda, VOID, VOID, [1]);
initMetadataForClass(asyncStreamWriter$1, VOID, VOID, VOID, VOID, [0, 3]);
initMetadataForInterface(SyncLengthStream, 'SyncLengthStream');
initMetadataForClass(SyncStreamBase, 'SyncStreamBase', SyncStreamBase.l1x, VOID, [AutoCloseable, SyncLengthStream]);
initMetadataForClass(ReadonlySyncStreamBase, 'ReadonlySyncStreamBase');
initMetadataForClass(MemorySyncStreamBase, 'MemorySyncStreamBase', MemorySyncStreamBase.q1x);
initMetadataForInterface(SyncInputStream, 'SyncInputStream', VOID, VOID, [AutoCloseable]);
initMetadataForInterface(SyncPositionStream, 'SyncPositionStream');
initMetadataForInterface(SyncOutputStream, 'SyncOutputStream', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncStream, 'SyncStream', VOID, VOID, [AutoCloseable, SyncInputStream, SyncPositionStream, SyncOutputStream, SyncLengthStream]);
initMetadataForClass(SliceSyncStreamBase, 'SliceSyncStreamBase');
//endregion
//region block: init
Companion_instance = new Companion();
//endregion
//region block: exports
export {
  write as writewjg6v0v9v7gt,
  asyncStreamWriter as asyncStreamWriter3ock1ljgyrdbd,
  copyTo as copyTo30i4m6zj8kjfa,
  getAvailable_0 as getAvailable3luskqy8lu1u2,
  hasAvailable_0 as hasAvailable2aj6ejlir0a2a,
  readAll as readAll1pkrq4jwoqns4,
  readBytesExact as readBytesExact305h8zdeltghk,
  readBytesUpTo as readBytesUpTo2jsx0o5buj2sw,
  readBytesUpTo_0 as readBytesUpTo1px2t44z4b9v7,
  readLine as readLine1dpyp1tbzc63w,
  readS16LE as readS16LE3rt2utyxlgw3g,
  readS32LE as readS32LE2r371m40u4y6y,
  readS32 as readS325wl7ebgpu38s,
  readStream as readStream3f0dxaq1c55fg,
  readStringz as readStringzzxx8hll1ncys,
  readString as readString3h14fm47a2tde,
  readU16 as readU162q6ft3yjssyvs,
  readU32LE as readU32LE31t9li7x6s60w,
  sliceHere as sliceHere162e6oimkowhf,
  sliceStart as sliceStart186j1d4dpd1wx,
  write16LE as write16LE1hc231hmo94he,
  write32BE as write32BE21w0wpwitaypp,
  write32LE as write32LE1tnk0giwkbrpc,
  write8 as write88m676whmym9y,
  writeBytes as writeBytes51i911pexb89,
  write$default as write$default33b74pnsnzha9,
  AsyncGetLengthStream as AsyncGetLengthStream219k26r6v6js2,
  AsyncGetPositionStream as AsyncGetPositionStream2f8n5516y4rp7,
  AsyncOutputStream as AsyncOutputStreamkoco1dsjo5gm,
  AsyncStreamBase as AsyncStreamBaseze8sfl15nwf0,
  AsyncStream as AsyncStream2lau9k1bvym4m,
  FastByteArrayInputStream as FastByteArrayInputStream1jjm4ufd0tkh5,
  MemorySyncStream as MemorySyncStreamw5bwb9yy0cam,
  MemorySyncStream_0 as MemorySyncStream1uv927me2xl9s,
  buffered as buffered29ldm4q6ez2xm,
  get_eof as get_eofaukbsoaf5jcj,
  openAsync as openAsync37anb1e84urmo,
  openFastStream as openFastStream2r4uuohoj0wpo,
  openSync as openSync2m3qn99fqytu0,
  readAll_0 as readAll3m5rixujsbctr,
  readBytes_0 as readBytes3l26albs0coyl,
  readS32BE_0 as readS32BE1vkzsiuy9pof1,
  readStream_0 as readStream3s64ivrsklqly,
  readStringz_0 as readStringz3jxaogr49n5ys,
  readString_0 as readString20u8kjncp0xlx,
  readString_1 as readString3106ot9qwcir2,
  readU8 as readU82o15i0epsnmc5,
  skipToAlign as skipToAlignusebk6ndjvs1,
  sliceStart_0 as sliceStart237tx6t7cytus,
  toAsyncStream as toAsyncStream3ow20wz4trxzb,
  toAsync_0 as toAsync26jtc2k5wi4gn,
  toAsync as toAsync2pa2d6thtq8t4,
  toAsync_1 as toAsyncc87ncfb6nti7,
  toSyncOrNull as toSyncOrNull2d7etdx5kh7ns,
  toSyncStream as toSyncStream3g0dpktigjx33,
  write32BE_0 as write32BE32zetfyrv09xq,
  write8_0 as write81fg3kayjaelgo,
  writeBytes_0 as writeBytes3aje3m4oawkwy,
};
//endregion
